<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="主题" required>
      <a-input v-model="form.data.title"/>
    </a-form-model-item>
    <a-form-model-item label="品牌" required>
      <a-select v-model="form.data.brandId">
        <a-select-option
          :key="item.id"
          :value="item.id"
          :title="item.name"
v-for="item in goodsBrand.data">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="副主题" required>
      <a-input v-model="form.data.subTitle"/>
    </a-form-model-item>
    <a-form-model-item label="tags">
      <div class="a-input">
        <multi-tag-editor v-model="form.data.tags"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="发布时间" required>
      <a-date-picker
        v-model="form.data.postAt"
        value-format="YYYY-MM-DDTHH:mm:ss"
        :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
        type="datetime"
        placeholder="选择日期时间">
      </a-date-picker>
    </a-form-model-item>
    <a-form-model-item label="封面图片" required>
      <div class="a-input">
        <simple-uploader v-model="form.data.coverPath"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="详情头部图片" required>
      <div class="a-input">
        <simple-uploader v-model="form.data.topImagePath"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="内容">
      <html-editor v-model="form.data.content"/>
    </a-form-model-item>
    <a-form-model-item>
     <a-space>
       <a-button type="primary" v-if="!brandNewsId" @click="onAdd">创建</a-button>
       <a-button type="primary" v-if="brandNewsId" @click="onUpdate">更新</a-button>
       <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
     </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import moment from 'moment';
import {
  _queryGoodsBrands,
} from '@/api/goodsBrandApi';
import {
  _queryBrandNews,
  _addBrandNews,
  _updateBrandNews,
} from '@/api/brandNewsApi';
import SimpleUploader from '@/components/SimpleUploader.vue';
import HtmlEditor from '@/components/HtmlEditor.vue';
import MultiTagEditor from '@/components/MultiTagEditor.vue';

async function getBrandNews() {
  const result = await _queryBrandNews(this.brandNewsId);
  if (result) {
    this.form.data.title = result.title;
    this.form.data.subTitle = result.subTitle;
    this.form.data.postAt = result.postAt;
    this.form.data.brandId = result.brandId;
    this.form.data.coverPath = result.coverPath;
    this.form.data.topImagePath = result.topImagePath;
    this.form.data.content = result.content;
    this.form.data.tags = result.tags ? result.tags.split(',') : [];
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addBrandNews({
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        postAt: this.form.data.postAt,
        brandId: this.form.data.brandId,
        coverPath: this.form.data.coverPath,
        topImagePath: this.form.data.topImagePath,
        content: this.form.data.content,
        tags: this.form.data.tags ? this.form.data.tags.join(',') : null,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateBrandNews(this.brandNewsId, {
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        postAt: this.form.data.postAt,
        brandId: this.form.data.brandId,
        coverPath: this.form.data.coverPath,
        topImagePath: this.form.data.topImagePath,
        content: this.form.data.content,
        tags: this.form.data.tags ? this.form.data.tags.join(',') : null,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'BrandNewsEdit',
  components: {
    MultiTagEditor,
    HtmlEditor,
    SimpleUploader,
  },
  props: {
    brandNewsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    brandNewsId() {
      if (this.brandNewsId) {
        this.getBrandNews();
      }
    },
  },
  methods: {
    moment,
    onAdd,
    onUpdate,
    onCancel,
    getBrandNews,
  },
  data() {
    return {
      goodsBrand: {
        data: [],
      },
      form: {
        data: {
          title: '',
          subTitle: '',
          postAt: moment()
            .format('YYYY-MM-DDTHH:mm:ss'),
          brandId: '',
          coverPath: '',
          topImagePath: '',
          content: '',
          contentImages: '',
          tags: [],
        },
        rules: {
          title: [{ required: true, trigger: 'blur' }],
          code: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  async created() {
    const result = await _queryGoodsBrands({});
    this.goodsBrand.data = result.content;
    if (this.brandNewsId) {
      this.getBrandNews();
    }
  },
};
</script>
